import { useState, useEffect } from 'react';
import api from 'services/api';

const TYPE_LABELS = {
  creation_agent: 'Creation agent', modification_agent: 'Modif. agent',
  contrat_travail: 'Contrat travail', conge: 'Conge',
  incident: 'Incident', facture: 'Facture', depense: 'Depense',
};

const STATUT_STYLES = {
  en_attente: { bg: 'rgba(217,119,6,0.08)', color: '#D97706' },
  approuve: { bg: 'rgba(26,135,84,0.08)', color: '#1A8754' },
  rejete: { bg: 'rgba(220,38,38,0.08)', color: '#DC2626' },
};

export default function Validations() {
  const [tab, setTab] = useState('attente');
  const [attente, setAttente] = useState([]);
  const [historique, setHistorique] = useState([]);
  const [stats, setStats] = useState({ en_attente: 0, approuve: 0, rejete: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [commenting, setCommenting] = useState(null);
  const [commentaire, setCommentaire] = useState('');

  const loadAll = async () => {
    setLoading(true);
    try {
      const [a, h, s] = await Promise.all([
        api.get('/validations/mes-validations'),
        api.get('/validations/historique'),
        api.get('/validations/stats'),
      ]);
      setAttente(a.data);
      setHistorique(h.data);
      setStats(s.data);
    } catch { setError('Erreur de chargement'); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadAll(); }, []);

  const handleDecision = async (id, decision) => {
    try {
      await api.put(`/validations/${id}/decider`, { decision, commentaire: commentaire || undefined });
      setCommenting(null);
      setCommentaire('');
      loadAll();
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur');
    }
  };

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';

  return (
    <div>
<div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">En attente</span>
            <div className="stat-card-icon orange"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg></div>
          </div>
          <div className="stat-card-value" style={{ color: 'var(--gss-warning)' }}>{stats.en_attente}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Approuvees</span>
            <div className="stat-card-icon green"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22,4 12,14.01 9,11.01"/></svg></div>
          </div>
          <div className="stat-card-value" style={{ color: 'var(--gss-success)' }}>{stats.approuve}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Rejetees</span>
            <div className="stat-card-icon red"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg></div>
          </div>
          <div className="stat-card-value">{stats.rejete}</div>
        </div>
      </div>

      {error && <div className="gss-alert gss-alert-error">{error}<button onClick={() => setError('')} style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer' }}>&times;</button></div>}

      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        {[{ id: 'attente', label: `En attente (${attente.length})` }, { id: 'historique', label: 'Historique' }].map(t => (
          <button key={t.id} className={`gss-btn ${tab === t.id ? 'gss-btn-primary' : ''}`} onClick={() => setTab(t.id)}>{t.label}</button>
        ))}
      </div>

      {loading ? <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Chargement...</p> : (
        <>
          {tab === 'attente' && (
            <div className="content-card">
              <div className="content-card-title">Demandes en attente de votre validation</div>
              {attente.length === 0 ? (
                <p style={{ color: 'var(--gss-text-light)', fontSize: '0.85rem', padding: '1rem 0' }}>Aucune demande en attente</p>
              ) : (
                <div className="gss-table-wrap">
                  <table className="gss-table">
                    <thead><tr><th>Type</th><th>Demandeur</th><th>Date</th><th>Role requis</th><th>Details</th><th>Actions</th></tr></thead>
                    <tbody>
                      {attente.map(v => (
                        <tr key={v.id}>
                          <td><span className="gss-badge" style={{ background: 'var(--gss-red-glow)', color: 'var(--gss-red)' }}>{TYPE_LABELS[v.type_demande] || v.type_demande}</span></td>
                          <td>{v.demandeur_prenom} {v.demandeur_nom}</td>
                          <td style={{ fontSize: '0.78rem', color: 'var(--gss-text-light)' }}>{formatDate(v.date_demande)}</td>
                          <td><span style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: 600, color: 'var(--gss-text-secondary)' }}>{v.role_validateur}</span></td>
                          <td style={{ fontSize: '0.78rem', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.donnees ? JSON.stringify(v.donnees).substring(0, 60) : '-'}</td>
                          <td>
                            {commenting === v.id ? (
                              <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center' }}>
                                <input className="gss-input" style={{ maxWidth: 150, fontSize: '0.75rem' }} placeholder="Commentaire..." value={commentaire} onChange={e => setCommentaire(e.target.value)} />
                                <button className="gss-btn-sm" style={{ background: 'rgba(26,135,84,0.06)', color: '#1A8754', borderColor: '#1A8754' }} onClick={() => handleDecision(v.id, 'approuve')}>OK</button>
                                <button className="gss-btn-sm gss-btn-danger" onClick={() => handleDecision(v.id, 'rejete')}>Non</button>
                                <button className="gss-btn-sm" onClick={() => setCommenting(null)}>&times;</button>
                              </div>
                            ) : (
                              <div style={{ display: 'flex', gap: '0.3rem' }}>
                                <button className="gss-btn-sm" style={{ background: 'rgba(26,135,84,0.06)', color: '#1A8754', borderColor: '#1A8754' }} onClick={() => handleDecision(v.id, 'approuve')}>Approuver</button>
                                <button className="gss-btn-sm gss-btn-danger" onClick={() => { setCommenting(v.id); setCommentaire(''); }}>Rejeter</button>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {tab === 'historique' && (
            <div className="content-card">
              <div className="content-card-title">Historique des validations</div>
              {historique.length === 0 ? (
                <p style={{ color: 'var(--gss-text-light)', fontSize: '0.85rem' }}>Aucun historique</p>
              ) : (
                <div className="gss-table-wrap">
                  <table className="gss-table">
                    <thead><tr><th>Type</th><th>Demandeur</th><th>Validateur</th><th>Decision</th><th>Commentaire</th><th>Date</th></tr></thead>
                    <tbody>
                      {historique.map(v => (
                        <tr key={v.id}>
                          <td><span className="gss-badge" style={{ background: 'var(--gss-red-glow)', color: 'var(--gss-red)' }}>{TYPE_LABELS[v.type_demande] || v.type_demande}</span></td>
                          <td>{v.demandeur_prenom} {v.demandeur_nom}</td>
                          <td>{v.validateur_prenom ? `${v.validateur_prenom} ${v.validateur_nom}` : '-'}</td>
                          <td>
                            <span className="gss-badge" style={{ background: STATUT_STYLES[v.statut]?.bg, color: STATUT_STYLES[v.statut]?.color }}>
                              {v.statut === 'approuve' ? 'Approuve' : v.statut === 'rejete' ? 'Rejete' : v.statut}
                            </span>
                          </td>
                          <td style={{ fontSize: '0.78rem', color: 'var(--gss-text-secondary)', maxWidth: 200 }}>{v.commentaire || '-'}</td>
                          <td style={{ fontSize: '0.78rem', color: 'var(--gss-text-light)' }}>{formatDate(v.date_decision)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
